import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import WaterSportsService from "../../services/watersports.service";

export const getWaterSports = createAsyncThunk(
  "waterSports/getWaterSports",
  async (item, thunkApi) => {
    try {
      const data = await WaterSportsService.getWaterSports(item);
      return { waterSports: data }; 
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  waterSports: [],
  
};

const waterSportsSlice = createSlice({ 
  name: "waterSports",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getWaterSports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWaterSports.fulfilled, (state, action) => {
        state.loading = false;
        state.travelPackagePrice = action.payload.travelPackagePrice; 
      })
      .addCase(getWaterSports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching data";
      });
  },
});

export default waterSportsSlice.reducer;
